import { combineReducers } from 'redux';

import dirty from './dirty';
import mealOptions, * as fromMealOptions from './mealOptions';
import nutritionSummaries from './nutritionSummaries';
import servings from './servings';
import status, * as fromStatus from './status';
import subtotals from './subtotals';
import suggestedPairings from './suggestedPairings';

export default combineReducers({
  status,
  dirty,
  mealOptions,
  nutritionSummaries,
  servings,
  subtotals,
  suggestedPairings,
});

export const selectBasketDirty = state => state.dirty;
export const selectMealOptions = state => state.mealOptions;
export const selectNutritionSummaries = state => state.nutritionSummaries;
export const selectServings = state => state.servings;
export const selectSubtotals = state => state.subtotals;
export const selectSuggestedPairings = state => state.suggestedPairings;

export const selectMealOptionsForMeal = (state, mealId) =>
  fromMealOptions.selectMealOptionsForMeal(state.mealOptions, mealId);

export const selectBasketIsLoaded = state => fromStatus.selectBasketIsLoaded(state.status);
